import React, { useState } from 'react'
import './userlogin.scss'
import API_CONSTANTS from '../api-constants'

const ResetPassword = () => {

    const [error, setError] = useState(false)
    const [emailError, setEmailError ] = useState('')
    const [emailEmpty, setEmailEmpty] = useState()
    const [email, setEmail] = useState('')
    const [showNoValidEmail, setShowNoValidEmail] = useState()
    const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    const [emailChangeSuccess, SetEmailChangeSuceess] = useState(false)

    const validateEmail = (e) => {
        if (e.target?.value && e.target.value.match(isValidEmail)) {
            setShowNoValidEmail(false);
            setEmail(e.target.value)
           
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
       
       // console.log(email, 'email')
        if (email === '') {
            setError(true)
            setEmailError('Udfyld venligst email')
        }
        !email && setEmailEmpty(true)
        if (email && email.length && email.match(isValidEmail)) {
         //   console.log('show password reset success')
            let url = `${API_CONSTANTS.fetchUrl}/newpassword`
            fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/SendResetPassword?Email=${email}&URL=${url}`, {
                method: "GET",
                headers: {
                    'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                    'Content-Type': 'application/x-www-form-urlencoded',
                },  
            })
                .then((res) => res.json())
                .then((result) => {
                  //  console.log(result, 'result')
         
                    if (result.result === 1) {
                        SetEmailChangeSuceess(true)
                    }
                })

        
        }
        else if (email.length && !email.match(isValidEmail)){
            setShowNoValidEmail(true);
        }
    };

    const emailChanged = (e) => {
       
        setEmail(e.target.value)
        setEmailEmpty(false)
        validateEmail(e)
    }
    return (
        <>
            {emailChangeSuccess === true ?
                <div className='reset-password'> 
                    <p className='title'>Din adgangskode skal nulstilles</p>
                    <p className='info'>Vi har sendt dig en email</p>
                    <p className='desc'>Tjek din email for at nulstille din adgangskode.  </p>
               </div> 
        :  
        <div className="login" >
            <p className='profile'>Din profil</p>
            <p className='emailtext'>Glemt adgangskode?</p>
            <p className='emailinfo'>Indtast din email for at modtage et link til at nulstille din adgangskode.</p>

                    <form className='loginflow' onSubmit={(e)=>handleSubmit(e)} style={{ marginTop: '30px' }}>
                       <label className='email-label'>Email</label>
                       <input className='email-input'  placeholder='Indtast email' onChange={(e) => emailChanged(e)} />
              
          
                       <button type="submit" className='send_btn' >Send</button>
                     </form>
            {error === true ?
                <div className='error-div'>
                   
                    {emailError && <span>{emailError}</span>}
                    
                </div> : null}
            </div>
                 }
        </>
            )
}

export default ResetPassword